const NS = 'TestimonialBlock';
const CLS = 'testimonialBlock';

import { mediaQuery } from '../../../../global/js/ara/mediaQuery';

export class TestimonialBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.mediaQuery = mediaQuery;
		this.$colVideo = this.$element.find(`.${CLS}-column--video`);
		this.$colSlider = this.$element.find(`.${CLS}-column--slider`);
		this.$slider = this.$element.find(`.${CLS}-slider`);

		$(window).on('resize', _.debounce(() => {
			this.adjustSliderSize();
		}, 50));

		this.initSlider();
		this.adjustSliderSize();

		setTimeout(() => {
			this.$element.css({
				opacity: 1
			});
			this.$slider.css({ opacity: 1 });
		}, 500);
	}

	initSlider() {
		this.$slider.slick({
			dots: true,
			dotsClass: 'slick-dots slick-dots--green',
			arrows: false,
			fade: true,
			swipe: false,
			infinite: true,
			mobileFirst: false,
			cssEase: 'ease-in-out',
			responsive: [
				{
					breakpoint: this.mediaQuery.BREAKPOINTS.MD,
					settings: {
						adaptiveHeight: true
					}
				}
			]
		}).on('afterChange', () => {
			this.adjustSliderSize();
		});
	}

	adjustSliderSize() {
		if(!this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.LG)) {
			if(this.$colSlider.height() > this.$colVideo.height()) {
				this.$colVideo.css({
					marginTop: `${this.$colSlider.height() - this.$colVideo.height()}px`
				});
			}
			else {
				this.$colVideo.css({
					marginTop: `0`
				});
			}
		}
		else {
			this.$colVideo.css({
				marginTop: `0`
			});
		}
	}
}
